import React from "react"
import { ButtonBase } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme => ({
  button: {
    width: "132px",
    height: "39px",
    backgroundColor: "#3374DA",
    color: "#FFF",
    fontFamily: "HiraKakuProN-W6, Hiragino Kaku Gothic ProN",
    fontSize: "10px",
    fontWeight: 500,
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "#2A5FB3",
    },
  },
}))
const BackButton = ({ onclick, title, ga }) => {
  const classes = useStyles()

  return (
    <ButtonBase
      id="backButton"
      onClick={onclick}
      className={classes.button}
      data-ga={ga}
    >
      {title}
    </ButtonBase>
  )
}

export default BackButton
